import { render } from "./CardCatalogo.vue?vue&type=template&id=2c4a9852&scoped=true"
import script from "./CardCatalogo.vue?vue&type=script&lang=js"
export * from "./CardCatalogo.vue?vue&type=script&lang=js"

import "./CardCatalogo.vue?vue&type=style&index=0&id=2c4a9852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4a9852"]])

export default __exports__